import cn from 'classnames';
import * as React from 'react';

import bem from 'utils/bem';
import PlanHeader, { PlanHeaderProps } from './PlanHeader';

type PickedHeaderProps = Pick<
  PlanHeaderProps,
  | 'className'
  | 'cost'
  | 'previousCost'
  | 'density'
  | 'description'
  | 'icon'
  | 'period'
  | 'isLimitedTime'
  | 'theme'
  | 'title'
>;

export type SubPeriodPlanHeaderProps = PickedHeaderProps;

const block = bem('sub-period-plan-header');

const SubPeriodPlanHeader: React.FC<SubPeriodPlanHeaderProps> = ({
  className,
  cost,
  previousCost,
  density,
  description,
  icon,
  period,
  isLimitedTime,
  theme,
  title,
}) => (
  <PlanHeader
    className={cn(block(), className)}
    {...{
      cost,
      previousCost,
      density,
      description,
      icon,
      period,
      isLimitedTime,
      theme,
      title,
    }}
  />
);

export default SubPeriodPlanHeader;
